import { mainSiteUrl } from '@/mocks/categories';
import { seoContent } from '@/mocks/seoData';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20product%20flatlay%20with%20sneakers%20hoodies%20accessories%20and%20bags%20arranged%20in%20elegant%20composition%20on%20warm%20beige%20textured%20surface%2C%20soft%20coral%20and%20cream%20color%20accents%20throughout%2C%20natural%20daylight%20streaming%20from%20left%20creating%20gentle%20shadows%2C%20clean%20editorial%20aesthetic%2C%20minimalist%20product%20photography%20style%2C%20harmonious%20color%20palette%20with%20warm%20neutral%20tones%2C%20refined%20ecommerce%20hero%20banner%20style%2C%20sophisticated%20and%20inviting%20atmosphere&width=1800&height=900&seq=itaobuy-hero-v3-2026&orientation=landscape"
          alt="ItaobuySpreadsheet shopping system product showcase"
          className="w-full h-full object-cover object-center"
          title="ItaobuySpreadsheet - Spreadsheet Shopping System Products"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 max-w-[1280px] mx-auto py-20">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {seoContent.heroTitle}
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl mb-10 leading-relaxed">
            {seoContent.heroSubtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              {seoContent.heroCta1}
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium text-sm rounded-full border border-white/25 hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              {seoContent.heroCta2}
              <i className="ri-external-link-line"></i>
            </a>
          </div>
          <p className="mt-8 text-xs text-white/50">
            Trusted by global shoppers using spreadsheet-based sourcing systems in 2026
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-xs text-white/50">Scroll to explore</span>
        <i className="ri-arrow-down-line text-white/60 text-lg animate-bounce"></i>
      </div>
    </section>
  );
}